export type User = {
  id: string;
  role: UserRole;
  userId: string;
  uid: string;
  given_name: string;
  family_name: string;
  nickname: string;
  name: string;
  picture: string;
  phone_number: string;
  email: string;
  email_verified: boolean;
  sub: string;
};

export interface IdToken {
  __raw: string;
  name?: string;
  given_name?: string;
  family_name?: string;
  middle_name?: string;
  nickname?: string;
  preferred_username?: string;
  profile?: string;
  picture?: string;
  website?: string;
  email?: string;
  email_verified?: boolean;
  gender?: string;
  birthdate?: string;
  zoneinfo?: string;
  locale?: string;
  phone_number?: string;
  phone_number_verified?: boolean;
  address?: string;
  updated_at?: string;
  iss?: string;
  aud?: string;
  exp?: number;
  nbf?: number;
  iat?: number;
  jti?: string;
  azp?: string;
  nonce?: string;
  auth_time?: string;
  at_hash?: string;
  c_hash?: string;
  acr?: string;
  amr?: string[];
  sub_jwk?: string;
  cnf?: string;
  sid?: string;
  org_id?: string;
  org_name?: string;
  [key: string]: any;
}

export enum UserRole {
  Vendor = 'VENDOR', // Vendor Admin
  Team = 'TEAM', // Vendor Team Member
  Admin = 'ADMIN', // Brighte Admin
  Manager = 'MANAGER', // BDM
  SuperAdmin = 'SUPERADMIN', // Brighte Super Admin
  Client = 'CLIENT',
  AdminOperations = 'ADMIN_OPERATIONS',
}

export interface UserTokenPayload {
  role: UserRole;
  userId: string;
  vendors: string[];
  clientId: string;
  iss: string;
  sub: string;
  aud: string[];
  iat: number;
  exp: number;
  scope: string;
  id?: string;
}

export enum ErrorTypes {
  TOKEN_ERROR = 'TOKEN_ERROR',
}

export type TokenError = {
  status: ErrorTypes;
  message: string;
};
